export default str =>
  str
    .split("<a")
    .map((a, i) => {
      if (i > 0) return '<a target="_blank"' + a
      return a
    })
    .join("")
